import CoachingSchedule from '../apps/coaching_schedule';
import React from 'react';
import ReactDOM from 'react-dom';

ReactDOM.render(
    <CoachingSchedule scheduleKey={ getScheduleKey() } />,
    document.getElementById('coaching-schedule')
);

function getScheduleKey() {
    const regex = new RegExp("[?&][uU](=([^&#]*)|&|#|$)");
    const result = regex.exec(window.location.href);

    if (!result || !result[2]) {
        const url = window.location.href.split(/[\?\#]/)[0];
        const parts = url.split('/').filter(el => el.trim().length);
        return decodeURIComponent(parts[parts.length - 1]).replace(/\+/g, " ");
    }

    return decodeURIComponent(result[2].replace(/\+/g, " "));
}

console.log('Loaded.');